// extracted by mini-css-extract-plugin
export default {"multi_button":"MultiButton_multi_button__qzIiN"};